"use client"
import { type ReactNode } from "react"
import { EpilogueParcel } from "./blocks/layout/EpilogueParcel"

// Renders the variant's body (which is responsible for any globe/graph it
// wants via <HudPersistentGlobeAndGraph />) plus the always-present
// EpilogueParcel that animates in when entering epilogue mode.

type HudVariantLayoutProps = {
  render: () => ReactNode
}

export const HudVariantLayout = ({ render }: HudVariantLayoutProps) => {
  return (
    <>
      {render()}
      <EpilogueParcel />
    </>
  )
}
